exports["IT"] = require("./IT.js");
exports["FR"] = require("./FR.js");